/** Upload/extraction lifecycle status for a medical billing summary file card. */
export enum MedSummaryFileStatus {
  UPLOADING = 'uploading',
  PROCESSING = 'processing',
  COMPLETED = 'completed',
  EXTRACTED = 'extracted',
  ERROR = 'error',
}
